import { useEffect } from 'react';
import { useAuth } from './auth.store.js';
/**
 * Gates the first render on session recovery.
 *
 * Both applications keep the access token in sessionStorage and the refresh
 * token in an HttpOnly cookie that outlives it, so "this tab has no access
 * token" and "this person is not signed in" are different statements. Every
 * screen that branches on `accessToken` has to wait for the difference to be
 * resolved, or a signed-in user meets a login form in a new tab.
 *
 * Returns false until the answer is known — render a loading state, not a login
 * form. Flashing the login form for the duration of one request is the same bug
 * in a shorter form, and on a slow connection it is long enough for a manager to
 * start typing into it.
 *
 * Kept as a hook rather than a call in `main.tsx` so the render blocks on it:
 * firing it at module scope would start the request but let the first paint
 * happen before it lands.
 */
export function useSessionBootstrap() {
    const bootstrapped = useAuth((state) => state.bootstrapped);
    useEffect(() => {
        // Read through `getState` rather than subscribing: this must run once on
        // mount, and depending on the action identity would be a lie about why.
        void useAuth.getState().bootstrap();
    }, []);
    return bootstrapped;
}
//# sourceMappingURL=use-session-bootstrap.js.map